import type { Context } from 'react';
import { createContext } from 'react';

import type { PageLoadData } from './types';

export interface PageDataLoadContextValue {
  readonly pageLoadData: PageLoadData;
}

export const PageDataLoadContext: Context<PageDataLoadContextValue | undefined> = createContext<
  PageDataLoadContextValue | undefined
>(undefined);
